import React from 'react';
import { Menubar } from 'primereact/menubar';
import MainNavStart from "./MainNavStart";
import MainNavEnd from "./MainNavEnd";

const MainNav = () => {
    return (
        <Menubar model={[]} start={(<MainNavStart />)} end={(<MainNavEnd />)} />
    )
}

export default MainNav;